import { StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { BaseStore } from '../base/base.store';

@Injectable({ providedIn: 'root' })
@StoreConfig({
    name: 'template',
    cache: {
        ttl: 15000
    }
})
export class TemplateStore extends BaseStore {
    constructor() {
        super();
    }
}
